import { get } from "lodash";
import { bootstrapHTML } from "../../shared/bootstrapHTML";
import { formatDateOnly, formatDollar, formatPercentage, parseFloatString, theVal } from "../../shared/utility";
import { getRsData } from "../Invoices/InvoiceLogic";
import { getPaymentAmount } from "../RSheets/RSheetsLogic";
import { getGCIRate, checkIfGCIOverride } from "../CRM/GCIBoard/gciLogic";

const headerHTML = `
<!doctype html>
<html lang="en">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<title>RS - Payment Report</title>
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet">
<style>
    ${bootstrapHTML}
  :root{
    --ink:#231f20;
    --muted:#6b6b6b;
    --line:#e6e6e6;
    --light:#f4f5f7;
    --brand:#e21e2e;           /* illicre red (approx) */
    --brand-dark:#c21927;
  }
  *{box-sizing:border-box}
  html,body{margin:0;color:var(--ink);font-family:Inter,system-ui,Arial,sans-serif}
  .page{
    margin: 32px auto;
    background:#fff;
  }
  .header{
    display:grid;
    grid-template-columns: 160px 1fr;
    gap: 24px;
    align-items:center;
    margin-bottom: 18px;
  }
  .logo{
    width:40px; height:auto;
  }
  .title{
    font-weight:600; letter-spacing:.18em; font-size:22px;
  }

 .meta-grid{
  display:grid;
  grid-template-columns: 1fr 1fr 1fr;   /* 3 sections; 3rd can be empty */
  gap: 20px 56px;                       /* row/column gaps */
  align-items:start;
  margin: 8px 0 22px;
}

.kvlist {
    display: grid;
    grid-template-columns: 112px 1fr;
    column-gap: 0px;
    row-gap: 3px;
    margin: 0;
    font-size: 10px;
    font-variant-numeric: tabular-nums;
}

.kvlist dt{
  margin:0;
  color:#666;
  font-weight:500;
  white-space:nowrap;
}
.kvlist dt::after{ content: ":"; padding-left:6px; }

.kvlist dd{
  margin:0;
  font-weight:500;
  color:#222;
  overflow-wrap:anywhere;                /* long names won't overflow */
}

/* Optional: stack on small screens */
@media (max-width: 900px){
  .meta-grid{ grid-template-columns: 1fr; }
}

  .bar {
    margin: 10px 0 8px;
    background: #f0f0f0;
    color: #3a3a3a;
    font-weight: 700;
    text-align: center;
    padding: 5px 12px;
    letter-spacing: .12em;
    font-size: 10px;
  }
  .bar--brand{
    background:var(--brand); color:#fff;
    margin-top:10px;
  }

  table{
    width:100%;
    border-collapse:collapse;
    font-size:10px;
    margin-bottom:16px;
  }
  th, td{
    padding:4px 10px;
    vertical-align:top;
  }
  thead th {
    font-weight: 700;
    color: #3a3a3a;
    border-bottom: 2px solid var(--line);
    background: #fafafa;
    text-transform: uppercase;
    font-size: 10px;
    letter-spacing: .06em;
}
  tbody tr{
    border-bottom:1px solid var(--line);
  }
  .group{
    color:var(--muted);
    font-weight:600;
    background:#fff;
  }
  .right{text-align:right}
  .center{text-align:center}

  /* Totals section */
  .totals-bar{
    background:#fff;
    border-top:2px solid var(--line);
    border-bottom:2px solid var(--line);
    color:var(--brand);
    font-weight:800;
    padding:10px 12px; margin-top:10px; letter-spacing:.12em;
    font-size: 10px;
  }
  .totals-grid{
    display:grid; grid-template-columns:1fr 1fr; gap:24px; margin-top:6px;
  }
  .totals-card{
    border:1px solid var(--line);
    border-radius:8px;
    padding:14px;
  }
  .totals-card h4{
    margin:.2rem 0 .6rem; font-size:10px; text-transform:uppercase; letter-spacing:.08em; color:#444;
  }
  .rowline{
    display:flex; justify-content:space-between; padding:3px 0; border-bottom:1px dashed #eee; font-size: 10px;
  }
  .rowline:last-child{border-bottom:0}
  .subtot{font-weight:700; color:var(--brand); !important;}
  .subtot span { color:var(--brand); !important; }
  .grand{
    display:flex; justify-content:space-between; align-items:center;
    font-weight:800; color:var(--brand); margin-top:12px; font-size:10px;
  }

    /* print */
    @media print{
        body{background:#fff}
        .page{width:auto;margin:0;padding:0}
        a{color:inherit;text-decoration:none}
    }
    @media print {
        .row { display:flex; flex-wrap:wrap; }
        .col-md-4 { flex: 0 0 33.333%; max-width: 33.333%; }
    }
    @media print {
        .page-break { break-before: page; }          /* modern */
        /* legacy synonym for older Chromium builds: */
        .page-break { page-break-before: always; }

        /* keep blocks together */
        .no-break     { break-inside: avoid; page-break-inside: avoid; }
        table, tr, td { break-inside: avoid; page-break-inside: avoid; }
    }
</style>
</head>
`;

const getName = (obj) => {
    let name = '';
    if (obj.company_name) {
        name = obj.company_name + ' ';
    }
    if (obj.first_name && obj.last_name) {
        const n = `${obj.first_name} ${obj.last_name}`;
        if (name) {
            name += ' - ' + n;
        } else {
            name = n;
        }
    }
    return name;
}

export const renderReportHTML = (all_data, chosen, illi_users) => {
    let content = '';
    let payments_distObj = {};
    all_data.invoices.forEach(adi => {
        if (chosen.invoice_ids.indexOf(adi.id) !== -1) {
            const invoice_id = adi.id;
            adi.payments.forEach(payment => {
                const payment_id = payment.id;
                if (chosen.payment_ids.indexOf(payment.id) !== -1) {
                    const obj = renderReportHTMLSection(all_data, invoice_id, payment_id, illi_users);
                    content += obj.html;
                    payments_distObj[payment_id] = obj.distObj;
                }
            })
        }
    })
    const finalHTML = `
        ${headerHTML}
        <body>
            ${content}
        </body>
        </html>
    `;
    return {
        finalHTML,
        payments_distObj
    };
}

const grabUserId = (contact_id, associates) => {
    let user_id = null;
    if (associates) {
        if (associates.length > 0) {
            associates.forEach(assoc => {
                if (contact_id === assoc.contact_id) {
                    user_id = assoc.connect_user_id;
                }
            })
        }
    }
    return user_id;
}

const retrieveInvoice = (all_data, invoice_id) => {
    console.log('retrieving invoice', all_data, invoice_id);
    let invoice = null; // **
    all_data.invoices.forEach(inv => {
        if (inv.id === invoice_id) {
            invoice = inv;
        }
    })
    return invoice;
}

const retrievePayment = (invoice, payment_id, data, sheetType) => {
    let payment = null; // **
    if (payment_id) {
        invoice.payments.forEach(p => {
            if (p.id === payment_id) {
                payment = p;
            }
        })
    } else {
        // simulate
        if (invoice.total_amount_due_this_invoice) {
            payment = {
                id: 0,
                payment_amount: invoice.total_amount_due_this_invoice
            }
        }
        // const json = invoice.json_data;
        // let payment_amount = 0;
        // if (json.entries) {
        //     json.entries.forEach(p => {
        //         // const flatFeeEnabled = (rsType === 'Consulting' 
        //         // || rsType === 'LeaseAssignmentFee'
        //         // || rsType == 6
        //         // || rsType == 9
        //         payment_amount = getPaymentAmount(data, p.option, null, sheetType);
        //     })
        // }
        // payment = {
        //     id: 0,
        //     payment_amount
        // };
    }
    return payment;
}

export const calculatePaymentSplits2 = (all_data, invoice_id, payment_id) => {
    console.log('calculatePaymentSplits2', all_data, invoice_id, payment_id);
    const distObj = {
        total_referrals: 0,
        total_presplits: 0,
        total_outside_brokers: 0,
        total_illi_associates: 0,
        total_house: 0,
        total_paid: 0,

        paymentVal: 0,
        lessee_commission: 0,
        lessor_commission: 0,

        commission_distribution_lessee: 0,
        commission_distribution_lessor: 0,

        presplits: [],

        lessee_outside_brokers: [],
        lessor_outside_brokers: []

    };
    const rs = all_data.rs;
    const rs_data = rs.json_data;
    const gci_entries = all_data.gci_entries;
    // INVOICE
    const invoice = retrieveInvoice(all_data, invoice_id);
    const payment = retrievePayment(invoice, payment_id, rs_data, rs.type);
    console.log('payment', payment);
    distObj.paymentVal = parseFloatString(payment?.payment_amount);
    distObj.paymentValAfterPresplits = parseFloatString(payment?.payment_amount);
    // PRE-SPLITS 
    const presplits = rs_data.presplits;
    presplits.forEach(pr => {
        // Default Dollar Value
        const prObj = {
            name: `${theVal(pr.first_name)} ${theVal(pr.last_name)}`,
            val: parseFloatString(pr.dollar_value),
            perc: '',
            applies_to: pr.presplit_applies_to
        };
        if (pr.presplit_applies_to !== 'Dollar Value') {
            // Percentage
            if (pr.percentage_value) {
                const percentage = parseFloatString(pr.percentage_value) * 0.01;
                prObj.val = percentage * distObj.paymentVal;
                prObj.perc = pr.percentage_value;
            }
        }
        distObj.total_referrals += prObj.val;
        distObj.total_presplits += prObj.val;
        console.log('looking at pr', prObj);
        if (prObj.applies_to === 'Both Lessor and Lessee') {
            distObj.paymentValAfterPresplits = distObj.paymentValAfterPresplits - prObj.val;
        } else if (prObj.applies_to === 'Lessee Only') {
            const objval = (0.01 * parseFloatString(rs_data.commission_distribution_lessee)) * prObj.val;
            distObj.paymentValAfterPresplits = distObj.paymentValAfterPresplits - objval;
        } else if (prObj.applies_to === 'Lessor Only') {
            const objval = (0.01 * parseFloatString(rs_data.commission_distribution_lessor)) * prObj.val;
            distObj.paymentValAfterPresplits = distObj.paymentValAfterPresplits - objval;
        }
        distObj.presplits.push(prObj);
    })
    // REDUCE BY PRESPLITS
    distObj.lessee_commission = (0.01 * parseFloatString(rs_data.commission_distribution_lessee)) * distObj.paymentValAfterPresplits;
    distObj.lessor_commission = (0.01 * parseFloatString(rs_data.commission_distribution_lessor)) * distObj.paymentValAfterPresplits;

    console.log('divided 2', rs_data, distObj, rs_data.commission_distribution_lessee, rs_data.commission_distribution_lessor);

    // POST-SPLIT LESSEE 
    // -----------------
    // LESSEE OUTSIDE BROKER 
    distObj.lessee_outside_brokers = [];
    distObj.lessee_postsplits = 0;
    rs_data.outside_broker.forEach(ob => {
        let dollar_value = parseFloatString(ob.percentage) * distObj.lessee_commission;
        distObj.lessee_outside_brokers.push({
            name: getName(ob),
            percentage: parseFloatString(ob.percentage),
            dollar_value
        });
        distObj.total_outside_brokers += dollar_value;
        distObj.lessee_postsplits += dollar_value;
    });

    // LESSEE REFERRAL
    // Lessee - Referrals
    distObj.lessee_referrals = []; // **
    if (rs_data.lessee_referral_firm_id) {
        if (rs_data.lessee_referral_firm_fee_amount_choice === 'Percentage') {
            let name = ``;
            if (rs_data.lessee_referral_firm_company_name) {
                name = rs_data.lessee_referral_firm_company_name;
            }
            if (rs_data.lessee_referral_firm_name && rs_data.lessee_referral_firm_lastname) {
                const n = `${rs_data.lessee_referral_firm_name} ${rs_data.lessee_referral_firm_lastname}`;
                if (name) {
                    name += ' - ' + n;
                } else {
                    name = n;
                }
            }
            let percentage;
            let dollar_value;
            if (rs_data.lessee_referral_firm_fee_amount_choice === 'Percentage') {
                percentage = parseFloatString(rs_data.lessee_referral_firm_fee_amount_percentage) * 0.01;
                dollar_value = percentage * distObj.lessee_commission;
            } else {
                percentage = '';
                dollar_value = parseFloatString(rs_data.lessee_referral_firm_fee_amount);
            }
            distObj.lessee_referrals.push({
                name,
                percentage,
                dollar_value 
            });
            distObj.total_referrals += dollar_value;
            distObj.lessee_postsplits += dollar_value;
        } else {
            // DOLLAR VALUE 
            const dollar_value = parseFloatString(rs_data.lessee_referral_firm_fee_amount);
            let name = ``;
            if (rs_data.lessee_referral_firm_company_name) {
                name = rs_data.lessee_referral_firm_company_name;
            }
            if (rs_data.lessee_referral_firm_name && rs_data.lessee_referral_firm_lastname) {
                const n = `${rs_data.lessee_referral_firm_name} ${rs_data.lessee_referral_firm_lastname}`;
                if (name) {
                    name += ' - ' + n;
                } else {
                    name = n;
                }
            }
            distObj.lessee_referrals.push({
                name,
                percentage: '',
                dollar_value 
            });
            distObj.total_referrals += dollar_value;
            distObj.lessor_postsplits += dollar_value;
        }
    }
    if (rs_data.lessee_referrals) {
        rs_data.lessee_referrals.forEach(lr => {
            let percentage;
            let dollar_value; 
            if (lr.fee_amount_choice === 'Percentage') {
                percentage = (parseFloatString(lr.fee_amount_percentage) * 0.01);
                dollar_value = percentage * distObj.lessee_commission;
            } else {
                percentage = '';
                dollar_value = parseFloatString(lr.fee_amount);
            }
            distObj.total_referrals += dollar_value;
            distObj.lessee_postsplits += dollar_value;
        })
    }

    // LESSOR 
    // ------
    // OUTSIDE BROKERS
    distObj.lessor_outside_brokers = [];
    distObj.lessor_postsplits = 0;
    rs_data.lessor_outside_broker.forEach(ob => {
        let dollar_value = parseFloatString(ob.percentage) * distObj.lessor_commission;
        distObj.lessor_outside_brokers.push({
            name: getName(ob),
            percentage: parseFloatString(ob.percentage),
            dollar_value
        });
        distObj.total_outside_brokers += dollar_value;
        distObj.lessor_postsplits += dollar_value;
    });
    // REFERRALS 
    distObj.lessor_referrals = [];
    if (rs_data.referral_firm_id) {
        if (rs_data.referral_firm_fee_amount_choice === 'Percentage') {
            let name = ``;
            if (rs_data.referral_firm_company_name) {
                name = rs_data.referral_firm_company_name;
            }
            if (rs_data.referral_firm_name && rs_data.referral_firm_lastname) {
                const n = `${rs_data.referral_firm_name} ${rs_data.referral_firm_lastname}`;
                if (name) {
                    name += ' - ' + n;
                } else {
                    name = n
                }
            }
            const percentage = parseFloatString(rs_data.referral_firm_fee_amount_percentage) * 0.01;
            const dollar_value = percentage * distObj.lessor_commission;
            distObj.lessor_referrals.push({
                name,
                percentage,
                dollar_value 
            });
            distObj.total_referrals += dollar_value;
            distObj.lessor_postsplits += dollar_value;
        } else {
            // DOLLAR VALUE
            const dollar_value = parseFloatString(rs_data.referral_firm_fee_amount);
            let name = ``;
            if (rs_data.referral_firm_company_name) {
                name = rs_data.referral_firm_company_name;
            }
            if (rs_data.referral_firm_name && rs_data.referral_firm_lastname) {
                const n = `${rs_data.referral_firm_name} ${rs_data.referral_firm_lastname}`;
                if (name) {
                    name += ' - ' + n;
                } else {
                    name = n
                }
            }
            distObj.lessor_referrals.push({
                name,
                percentage: '',
                dollar_value 
            });
            distObj.total_referrals += dollar_value;
            distObj.lessor_postsplits += dollar_value;
        }
    }
    if (rs_data.lessor_referrals) {
        rs_data.lessor_referrals.forEach(lr => {
            let name = lr.company_name;
            const n = `${lr.first_name} ${lr.last_name}`;
            if (name) {
                name += ' - ' + n;
            } else {
                name = n;
            }
            let percentage = '';
            let dollar_value = 0;
            if (lr.fee_amount_choice === 'Percentage') {
                percentage = parseFloatString(lr.fee_amount_percentage) * 0.01;
                dollar_value = percentage * distObj.lessor_commission;
            } else if (lr.amount_choice === 'Value') {
                dollar_value = parseFloatString(lr.fee_amount);
            }
            distObj.lessor_referrals.push({
                name,
                percentage,
                dollar_value
            })
            distObj.total_referrals += dollar_value;
            distObj.lessor_postsplits += dollar_value;
        })
    }

    distObj.lessee_commission -= distObj.lessee_postsplits;
    distObj.lessor_commission -= distObj.lessor_postsplits;

    return distObj;
}

const getEvenCommissionPercentage = (invoices = [], invoice_id, payment_id) => {
  // determine which array and which payment payment_id is

  let totalPayments = 0;
  let payment_index = 0;
  invoices.forEach(inv => {
    let isCurrentInvoice = false;
    if (inv.id === invoice_id) {
        isCurrentInvoice = true;
    }
    if (inv.payments) {
        inv.payments.forEach((payment, index) => {
            if (payment.id === payment_id) {
                payment_index = index;
            }
        });
    }
    if (inv.data) {
        if (inv.data.entries) {
            if (inv.data.entries) {
                inv.data.entries.forEach((ide,i) => {
                    if (i === 0) {
                        // display: true doesn't apply here
                        totalPayments++;
                    } else {
                        if (!ide.display_only) {
                            totalPayments++;
                        }
                    }
                    
                });
            }
        }
    }
  })

  if (totalPayments === 0) return 0;
  const percs = +(1 / totalPayments).toFixed(4);
  console.log('total paymintz', totalPayments, percs);

  return percs;
}

const getPercentageOfTotal = (numerator, denominator) => {
  return Number(((Number(numerator).toFixed(2)) / (Number(denominator).toFixed(2))).toFixed(2));
};

export const calculatePaymentSplits = (all_data, invoice_id, payment_id, last_gci_level, override, illi_users) => {
    console.log('calculating payment splits report', all_data, invoice_id, payment_id, last_gci_level);
    const distObj = {
        total_referrals: 0,
        total_presplits: 0,
        total_outside_brokers: 0,
        total_illi_associates: 0,
        total_house: 0,
        total_paid: 0,

        paymentVal: 0,
        lessee_commission: 0,
        lessor_commission: 0,

        commission_distribution_lessee: 0,
        commission_distribution_lessor: 0,

        presplits: [],

        lessee_outside_brokers: [],
        lessor_outside_brokers: []

    };
    const rs = all_data.rs;
    const rs_data = rs.json_data;
    const gci_entries = all_data.gci_entries;
    // INVOICE
    const invoice = retrieveInvoice(all_data, invoice_id);
    const payment = retrievePayment(invoice, payment_id, rs_data, rs.type);
    console.log('payment', payment);
    distObj.paymentVal = parseFloatString(payment?.payment_amount);
    distObj.paymentValBeforePresplits = parseFloatString(payment?.payment_amount);

    console.log('payment 2', distObj);

    const associateCommissionObj = {}

    // Split the referrals / outside brokers if more than 1 invoice. 
    let split_percentage = 0;
    if (all_data.invoices.length > 0) {
        //split_percentage = getEvenCommissionPercentage(all_data.invoices);
        split_percentage = getPercentageOfTotal(distObj.paymentVal, all_data.transaction_commission);
    }
    console.log('split_percentage', split_percentage);

    let presplits_to_lessee = 0;
    let presplits_to_lessor = 0;
    let presplits_to_both = 0;
    
    // PRE-SPLITS 
    const presplits = rs_data.presplits;
    presplits.forEach(pr => {
        // Default Dollar Value
        const prObj = {
            name: `${theVal(pr.first_name)} ${theVal(pr.last_name)}`,
            val: parseFloatString(pr.dollar_value),
            perc: '',
            applies_to: pr.presplit_applies_to
        };
        if (pr.presplit_applies_to !== 'Dollar Value') {
            // Percentage
            if (pr.percentage_value) {
                const percentage = parseFloatString(pr.percentage_value) * 0.01;
                prObj.val = percentage * distObj.paymentVal;
                prObj.perc = pr.percentage_value;
            }
        }
        distObj.total_referrals += prObj.val;
        distObj.total_presplits += prObj.val;
        console.log('looking at pr', prObj);
        if (prObj.applies_to === 'Both Lessor and Lessee') {
            presplits_to_both = presplits_to_both + prObj.val;
        } else if (prObj.applies_to === 'Lessee Only') {
            presplits_to_lessee = presplits_to_lessee + prObj.val;
        } else if (prObj.applies_to === 'Lessor Only') {
            presplits_to_lessor = presplits_to_lessee + prObj.val;
        }
        distObj.presplits.push(prObj);
    })

    // DISTRIBUTE FIRST
    distObj.paymentValBeforePresplits = distObj.paymentValBeforePresplits - presplits_to_both;
    console.log('pplessee', (0.01 * parseFloatString(rs_data.commission_distribution_lessee)), distObj.paymentValBeforePresplits);
    distObj.lessee_commission = (0.01 * parseFloatString(rs_data.commission_distribution_lessee)) * distObj.paymentValBeforePresplits;
    distObj.lessee_commission = distObj.lessee_commission - presplits_to_lessee;
    console.log('presplits_to_lessee', presplits_to_lessee, distObj.lessee_commission);

    distObj.lessor_commission = (0.01 * parseFloatString(rs_data.commission_distribution_lessor)) * distObj.paymentValBeforePresplits;
    distObj.lessor_commission = distObj.lessor_commission - presplits_to_lessor;
    console.log('presplits_to_lessor', presplits_to_lessor, distObj.lessor_commission);

    // APPLY 
    
    console.log('divided before', distObj.lessee_commission, distObj.lessor_commission);
    console.log('divided 2', rs_data, distObj.lessee_commission, distObj, rs_data.commission_distribution_lessee, rs_data.commission_distribution_lessor);

    // POST-SPLIT LESSEE 
    // -----------------
    // LESSEE OUTSIDE BROKER 
    distObj.lessee_outside_brokers = [];
    distObj.lessee_postsplits = 0;
    rs_data.outside_broker.forEach(ob => {
        let dollar_value = parseFloatString(ob.percentage) * distObj.lessee_commission;
        distObj.lessee_outside_brokers.push({
            name: getName(ob),
            percentage: parseFloatString(ob.percentage),
            dollar_value
        });
        distObj.total_outside_brokers += dollar_value;
        distObj.lessee_postsplits += dollar_value;
    });

    // LESSEE REFERRAL
    // Lessee - Referrals
    distObj.lessee_referrals = []; // **
    if (rs_data.lessee_referral_firm_id) {
        if (rs_data.lessee_referral_firm_fee_amount_choice === 'Percentage') {
            let name = ``;
            if (rs_data.lessee_referral_firm_company_name) {
                name = rs_data.lessee_referral_firm_company_name;
            }
            if (rs_data.lessee_referral_firm_name && rs_data.lessee_referral_firm_lastname) {
                const n = `${rs_data.lessee_referral_firm_name} ${rs_data.lessee_referral_firm_lastname}`;
                if (name) {
                    name += ' - ' + n;
                } else {
                    name = n;
                }
            }
            let percentage;
            let dollar_value;
            percentage = parseFloatString(rs_data.lessee_referral_firm_fee_amount_percentage) * 0.01;
            dollar_value = percentage * distObj.lessee_commission;
            distObj.lessee_referrals.push({
                name,
                percentage,
                dollar_value,
                choice: 'percentage'
            });
            distObj.total_referrals += dollar_value;
            distObj.lessee_postsplits += dollar_value;
        } else {
            // DOLLAR VALUE 
            let dollar_value = parseFloatString(rs_data.lessee_referral_firm_fee_amount);
            let name = ``;
            if (rs_data.lessee_referral_firm_company_name) {
                name = rs_data.lessee_referral_firm_company_name;
            }
            if (rs_data.lessee_referral_firm_name && rs_data.lessee_referral_firm_lastname) {
                const n = `${rs_data.lessee_referral_firm_name} ${rs_data.lessee_referral_firm_lastname}`;
                if (name) {
                    name += ' - ' + n;
                } else {
                    name = n;
                }
            }
            if (dollar_value && split_percentage) {
                dollar_value = dollar_value * split_percentage;
            }
            distObj.lessee_referrals.push({
                name,
                percentage: '',
                dollar_value,
                choice: 'value'
            });
            distObj.total_referrals += dollar_value;
            distObj.lessee_postsplits += dollar_value;
        }
    }
    if (rs_data.lessee_referrals) {
        rs_data.lessee_referrals.forEach(lr => {
            let name = lr.company_name;
            const n = `${lr.first_name} ${lr.last_name}`;
            if (name) {
                name += ' - ' + n;
            } else {
                name = n;
            }
            let percentage;
            let dollar_value; 
            let choice;
            if (lr.fee_amount_choice === 'Percentage') {
                percentage = (parseFloatString(lr.fee_amount_percentage) * 0.01);
                dollar_value = percentage * distObj.lessee_commission;
                choice = 'percentage';
            } else {
                percentage = '';
                dollar_value = parseFloatString(lr.fee_amount);
                choice = 'value';
                if (dollar_value && split_percentage) {
                    dollar_value = dollar_value * split_percentage;
                }
            }
            distObj.lessee_referrals.push({
                name,
                percentage,
                dollar_value,
                choice
            });
            distObj.total_referrals += dollar_value;
            distObj.lessee_postsplits += dollar_value;
        })
    }

    // LESSOR 
    // ------
    // OUTSIDE BROKERS
    distObj.lessor_outside_brokers = [];
    distObj.lessor_postsplits = 0;
    rs_data.lessor_outside_broker.forEach(ob => {
        let dollar_value = parseFloatString(ob.percentage) * distObj.lessor_commission;
        distObj.lessor_outside_brokers.push({
            name: getName(ob),
            percentage: parseFloatString(ob.percentage),
            dollar_value
        });
        distObj.total_outside_brokers += dollar_value;
        distObj.lessor_postsplits += dollar_value;
    });
    // REFERRALS 
    distObj.lessor_referrals = [];
    if (rs_data.referral_firm_id) {
        if (rs_data.referral_firm_fee_amount_choice === 'Percentage') {
            let name = ``;
            if (rs_data.referral_firm_company_name) {
                name = rs_data.referral_firm_company_name;
            }
            if (rs_data.referral_firm_name && rs_data.referral_firm_lastname) {
                const n = `${rs_data.referral_firm_name} ${rs_data.referral_firm_lastname}`;
                if (name) {
                    name += ' - ' + n;
                } else {
                    name = n
                }
            }
            const percentage = parseFloatString(rs_data.referral_firm_fee_amount_percentage) * 0.01;
            let dollar_value = percentage * distObj.lessor_commission;
            distObj.lessor_referrals.push({
                name,
                percentage,
                dollar_value, 
                choice: 'percentage'
            });
            distObj.total_referrals += dollar_value;
            distObj.lessor_postsplits += dollar_value;
        } else {
            // DOLLAR VALUE
            let dollar_value = parseFloatString(rs_data.referral_firm_fee_amount);
            let name = ``;
            if (rs_data.referral_firm_company_name) {
                name = rs_data.referral_firm_company_name;
            }
            if (rs_data.referral_firm_name && rs_data.referral_firm_lastname) {
                const n = `${rs_data.referral_firm_name} ${rs_data.referral_firm_lastname}`;
                if (name) {
                    name += ' - ' + n;
                } else {
                    name = n
                }
            }
            if (dollar_value && split_percentage) {
                dollar_value = dollar_value * split_percentage;
            }
            distObj.lessor_referrals.push({
                name,
                percentage: '',
                dollar_value,
                choice: 'value'
            });
            distObj.total_referrals += dollar_value;
            distObj.lessor_postsplits += dollar_value;
        }
    }
    if (rs_data.lessor_referrals) {
        rs_data.lessor_referrals.forEach(lr => {
            let name = lr.company_name;
            const n = `${lr.first_name} ${lr.last_name}`;
            if (name) {
                name += ' - ' + n;
            } else {
                name = n;
            }
            let percentage = '';
            let dollar_value = 0;
            let choice = '';
            if (lr.fee_amount_choice === 'Percentage') {
                percentage = parseFloatString(lr.fee_amount_percentage) * 0.01;
                dollar_value = percentage * distObj.lessor_commission;
                choice = 'percentage';
            } else if (lr.amount_choice === 'Value') {
                dollar_value = parseFloatString(lr.fee_amount);
                choice = 'value';
                if (dollar_value && split_percentage) {
                    dollar_value = dollar_value * split_percentage;
                }
            }
            distObj.lessor_referrals.push({
                name,
                percentage,
                dollar_value,
                choice
            })
            distObj.total_referrals += dollar_value;
            distObj.lessor_postsplits += dollar_value;
        })
    }

    distObj.lessee_commission -= distObj.lessee_postsplits;
    distObj.lessor_commission -= distObj.lessor_postsplits;

    console.log('distObj2', distObj);

    // ASSOCIATES
    // Lessee
    distObj.lessee_illi_associates = [];
    rs_data.commission_splits_agent2.forEach(csa => {
        
        console.log('rs_data', csa.Percentage, rs_data.commission_distribution_lessee, distObj.lessee_commission);
        const dollar_value = (parseFloatString(csa.Percentage) * 0.01) * distObj.lessee_commission;
        // find the associated GCIB by user_id, invoice_id and side
        const user_id = grabUserId(csa.id, all_data.associates);
        
        let associate_split_percent = 0;
        let due_to_associate_number = 0;
        let house_split_number = 0;
        let house_split_percent = 0;

        // prevent duplicates
        let user_gcibs = [];
        let seen = new Set();

        if (invoice.gcibs) {
            invoice.gcibs.forEach(gcib => {
                const { json_data } = gcib;

                if (
                    user_id === gcib.user_id &&
                    json_data.associate_side_on_rs === 'Lessee' &&
                    !seen.has(gcib.user_id)
                ) {
                    seen.add(gcib.user_id);
                    user_gcibs.push(gcib);
                }
            });
        }

        console.log('user_gcibs lessee', user_gcibs, payment_id);

        if (user_gcibs.length === 0) {
            // FRESH NO RECORDS
            const dv = dollar_value;
            const gci_check_obj = {
                contact_id: csa.id,
                rs_data,
                side: 'Lessee'
            };
            const gci_rate = getGCIRate(last_gci_level, gci_entries, gci_check_obj);
            // get last gci rate
            associate_split_percent = gci_rate * 100;
            due_to_associate_number = gci_rate * dv;
            house_split_number = (1 - gci_rate) * dv;
            house_split_percent = (1 - gci_rate) * 100;
            
            distObj.total_house += house_split_number;
            distObj.total_illi_associates += due_to_associate_number;

            distObj.lessee_illi_associates.push({
                name: csa.Name,
                percentage: parseFloatString(csa.Percentage),
                dollar_value: dv,
                user_id,
                associate_split_percent,
                house_split_number,
                house_split_percent,
                due_to_associate_number,
                is_override: checkIfGCIOverride(gci_check_obj)
            });
        } else {
            // HAS OTHER GCIBs
            user_gcibs.forEach(gcib => {
                const { json_data } = gcib;
                const payments = json_data.payments; 

                if (payments.length > 0) {
                    console.log('paymentz lessee', payments);
                    payments.forEach(p => {
                        if (p.payment_id === payment_id) {
                            console.log('gcibb', csa.Name, gcib, json_data, p);
                            
                            const gci_level = p.gci_level;
                            const gci_check_obj = {
                                contact_id: csa.id,
                                rs_data,
                                side: 'Lessee'
                            };
                            const gci_rate = getGCIRate(p.gci_level, gci_entries, gci_check_obj);
                            associate_split_percent = gci_rate * 100;
                            due_to_associate_number = gci_rate * dollar_value;
                            
                            house_split_number = due_to_associate_number * ((1 - gci_rate)/ gci_rate);
                            const dv = house_split_number + due_to_associate_number;
                            house_split_percent = (1 - gci_rate) * 100;

                            distObj.total_house += house_split_number;
                            distObj.total_illi_associates += due_to_associate_number;
                            
                            distObj.lessee_illi_associates.push({
                                name: csa.Name,
                                percentage: parseFloatString(csa.Percentage),
                                dollar_value: dv,
                                user_id,
                                associate_split_percent,
                                house_split_number,
                                house_split_percent,
                                due_to_associate_number,
                                gci_level,
                                gci_rate,
                                is_override: checkIfGCIOverride(gci_check_obj)
                            });
                            
                        }
                    })
                } else {
                    const gci_check_obj = {
                        contact_id: csa.id,
                        rs_data,
                        side: 'Lessor'
                    };
                    const the_gci_rate = json_data.gci_rate;
                    console.log('aqui 4', csa.Name, gcib, json_data.gci_rate, the_gci_rate);

                    const dv = dollar_value;
                    associate_split_percent = the_gci_rate * 100;
                    due_to_associate_number = the_gci_rate * dv;
                    house_split_percent = (1 - the_gci_rate) * 100;
                    house_split_number = (1 - the_gci_rate) * dv;
                    distObj.total_house += house_split_number;
                    distObj.total_illi_associates += due_to_associate_number;
                    
                    distObj.lessee_illi_associates.push({
                        name: csa.Name,
                        percentage: parseFloatString(csa.Percentage),
                        dollar_value: dv,
                        user_id,
                        associate_split_percent,
                        house_split_percent,
                        house_split_number,
                        due_to_associate_number
                    });
                }
            });
        }

    })

    // ASSOCIATES 
    // Lessor 
    distObj.lessor_illi_associates = [];
    rs_data.commission_splits_agent.forEach(csa => {
        console.log('rs_data', csa.Percentage, rs_data.commission_distribution_lessor, distObj.lessor_commission);
        const dollar_value = (parseFloatString(csa.Percentage) * 0.01) * distObj.lessor_commission;
        const user_id = grabUserId(csa.id, all_data.associates);
        
        let associate_split_percent = 0;
        let house_split_number = 0;
        let due_to_associate_number = 0;
        let house_split_percent = 0;

        let user_gcibs = [];
        let seen = new Set();
        
        if (invoice.gcibs) {
            invoice.gcibs.forEach(gcib => {
                const { json_data } = gcib;

                if (
                    user_id === gcib.user_id &&
                    json_data.associate_side_on_rs === 'Lessor' &&
                    !seen.has(gcib.user_id)
                ) {
                    seen.add(gcib.user_id);
                    user_gcibs.push(gcib);
                }
            });
        }

        console.log('user_gcibs lessor', user_gcibs, payment_id);

        if (user_gcibs.length === 0) {
            console.log('aqui 1');
            const dv = dollar_value;
            const gci_check_obj = {
                contact_id: csa.id, 
                rs_data,
                side: 'Lessor'
            };
            const gci_rate = getGCIRate(last_gci_level, gci_entries, gci_check_obj);
            // get last gci rate
            associate_split_percent = gci_rate * 100;
            due_to_associate_number = gci_rate * dv;
            house_split_number = (1 - gci_rate) * dv;
            house_split_percent = (1 - gci_rate) * 100;
            distObj.total_house += house_split_number;
            distObj.total_illi_associates += due_to_associate_number;

            distObj.lessor_illi_associates.push({
                name: csa.Name,
                percentage: parseFloatString(csa.Percentage),
                dollar_value: dv,
                user_id,
                associate_split_percent,
                house_split_number,
                house_split_percent,
                due_to_associate_number,
                is_override: checkIfGCIOverride(gci_check_obj)
            });
        } else {
            user_gcibs.forEach((gcib,i) => {
                const { json_data } = gcib;
                const payments = json_data.payments;
                console.log('pm', payments);
                console.log('aqui 2', payments);
                if (payments.length > 0) {
                    console.log('paymentz lessor', payments);
                    let hasCalculatedAlready = false;
                    payments.forEach(p => {
                        if (p.payment_id === payment_id) {
                            console.log('gcibb', csa.Name, gcib, json_data, p);

                            const gci_level = p.gci_level;
                            const gci_check_obj = {
                                contact_id: csa.id,
                                rs_data,
                                side: 'Lessor'
                            };
                            const gci_rate = getGCIRate(p.gci_level, gci_entries, gci_check_obj);
                            associate_split_percent = gci_rate * 100;
                            due_to_associate_number = gci_rate * dollar_value;
                            house_split_number = due_to_associate_number * ((1 - gci_rate) / gci_rate);
                            house_split_percent = (1 - gci_rate) * 100;
                            distObj.total_house += house_split_number;
                            const dv = house_split_number + due_to_associate_number;
                            
                            const objec = {
                                name: csa.Name,
                                percentage: parseFloatString(csa.Percentage),
                                dollar_value: dv,
                                user_id,
                                associate_split_percent,
                                house_split_number,
                                house_split_percent,
                                due_to_associate_number,
                                gci_level,
                                gci_rate,
                                is_override: checkIfGCIOverride(gci_check_obj)
                            };
                            console.log('objeck', objec);
                            distObj.lessor_illi_associates.push(objec);
                            distObj.total_illi_associates += due_to_associate_number;
                        }
                    })
                } else {
                    const gci_check_obj = {
                        contact_id: csa.id,
                        rs_data,
                        side: 'Lessor'
                    };
                    const dv = dollar_value;
                    const the_gci_rate = json_data.gci_rate;
                    console.log('aqui 4', csa.Name, gcib, json_data.gci_rate, the_gci_rate);
                    associate_split_percent = the_gci_rate * 100;
                    due_to_associate_number = the_gci_rate * dv;
                    house_split_number = (1 - the_gci_rate) * dv;
                    house_split_percent = (1 - the_gci_rate) * 100;
                    
                    distObj.total_house += house_split_number;
                    distObj.total_illi_associates += due_to_associate_number;

                    distObj.lessor_illi_associates.push({
                        name: csa.Name,
                        percentage: parseFloatString(csa.Percentage),
                        dollar_value: dv,
                        user_id,
                        associate_split_percent,
                        house_split_number,
                        house_split_percent,
                        due_to_associate_number
                    });
                    
                }
                
            });
        }

        
    })

    distObj.all_assocs = {};
    distObj.lessee_illi_associates.forEach(lia => {
        if (distObj.all_assocs.hasOwnProperty(lia.name)) {
            distObj.all_assocs[lia.name] += lia.due_to_associate_number;
        } else {
            distObj.all_assocs[lia.name] = lia.due_to_associate_number;
        }
    });
    distObj.lessor_illi_associates.forEach(lia => {
        if (distObj.all_assocs.hasOwnProperty(lia.name)) {
            distObj.all_assocs[lia.name] += lia.due_to_associate_number;
        } else {
            distObj.all_assocs[lia.name] = lia.due_to_associate_number;
        }
    });

    distObj.total_paid = distObj.total_outside_brokers + distObj.total_referrals + distObj.total_house + distObj.total_illi_associates;
    console.log('the_dist_obj FINAL', distObj);
    return distObj;
}

export const renderReportHTMLSection = (all_data, invoice_id, payment_id, illi_users) => {
    const rs = all_data.rs;
    const rs_data = rs.json_data;
    console.log('arsdata', rs_data, all_data);

    const distObj = calculatePaymentSplits(all_data, invoice_id, payment_id, null, null, illi_users);
    console.log('calculatedPaymentSplits', distObj);

    let lesseeTitle = 'Lessee';
    let lessorTitle = 'Lessor';
    if (rs.type === 3) {
        // Sublease
        lesseeTitle = 'Sub-Lessee';
        lessorTitle = 'Sub-Lessor';
    } else if (rs.type === 4) {
        // Sale
        lesseeTitle = 'Buyer';
        lessorTitle = 'Seller';
    }
    
    // INVOICE
    let invoice = null; // **
    all_data.invoices.forEach(inv => {
        if (inv.id === invoice_id) {
            invoice = inv;
        }
    })
    let payment = null; // **
    invoice.payments.forEach(p => {
        if (p.id === payment_id) {
            payment = p;
        }
    })
    if (!invoice || !payment) {
        return ``;
    }
    const check_payment = parseFloatString(payment.payment_amount); // **

    // LESSEE & LESSOR
    const renderLesseeNames = () => {
        const lessees = getRsData(rs_data, "lessees", { isArray: true });
        const names = lessees.map((l) => {
            const firstName = get(l, "name", "");
            const lastName = get(l, "last_name", "");
            const fullName = `${firstName} ${lastName}`;

            const companyName = get(l, "company_name", "");
            if (companyName) return companyName;

            if (fullName.trim() === "") return get(l, "company_name", "");
            
            return fullName;
        });
        return names.join(", ");
    }; // **

    const renderLessorNames = () => {
        const lessors = getRsData(rs_data, "lessors", { isArray: true });
        const names = lessors.map((l) => {
            const firstName = get(l, "name", "");
            const lastName = get(l, "last_name", "");
            const fullName = `${firstName} ${lastName}`;

            const companyName = get(l, "company_name", "");
            if (companyName) return companyName;

            if (fullName.trim() === "") return get(l, "company_name", "");
            
            return fullName;
        });
        return names.join(", ");
    }; // **

    const html = `
  <div class="page">

    <!-- Header -->
    <div class="header">
      <img class="logo" src="https://staging.connect.illicre.com/assets/logo.png" alt="illi commercial real estate logo">
      <div class="title">RS - Payment Report</div>
    </div>
<section class="bootstrap-wrapper">
    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <dl class="kvlist">
                    <dt>Payment Date</dt><dd>${formatDateOnly(payment.payment_date)}</dd>
                    <dt>illi#</dt><dd>${rs_data.illi_number}</dd>
                    <dt>Project Name</dt><dd>${rs.project_name}</dd>
                    <dt>Invoice #</dt><dd>${invoice.invoice_num}</dd>
                    <dt>Check Number</dt><dd>${payment.check_number}</dd>
                    <dt>Check Amount</dt><dd>${formatDollar(check_payment)}</dd>
                </dl>
            </div>
            <div class="col-6">
                <dl class="kvlist">
                    <dt>Lessee</dt><dd>${renderLesseeNames()}</dd>
                    <dt>Lessor</dt><dd>${renderLessorNames()}</dd>
                    <dt>Lease Signed Date</dt><dd>${rs_data.date_lease_signed}</dd>
                    ${payment.deposit_date ? 
                        `<dt>Deposit Date</dt><dd>${payment.deposit_date}</dd>` : ''}
                    ${payment.payment_received_date ? 
                        `<dt>Payment Received Date</dt><dd>${payment.payment_received_date}</dd>` : ''}</dd>
                </dl>
            </div>
        </div>
    </div>
</section>


    <!-- Pre-splits -->
    <div class="bar">PRE-SPLITS</div>
    <table aria-label="Pre-splits">
      <thead>
        <tr>
          <th>Referrals</th>
          <th class="center">Percentage</th>
          <th class="right">Dollar Value</th>
          <th class="center">Applies to</th>
        </tr>
      </thead>
      <tbody>
        ${distObj.presplits.length === 0 ? `
                <tr>
                    <td><em>None</em></td>
                    <td class="center"></td>
                    <td class="right"></td>
                    <td class="center"></td>
                </tr>
            ` : ''}
        ${distObj.presplits.map(pc => {
            return `
                <tr>
                    <td>${pc.name}</td>
                    <td class="center">${pc.perc ? formatPercentage(pc.perc) : ''}</td>
                    <td class="right">${formatDollar(pc.val)}</td>
                    <td class="center">${pc.applies_to}</td>
                </tr>
            `;
        }).join('')}
      </tbody>
    </table>

    <!-- Post-splits -->
    <div class="bar bar--brand">POST-SPLITS</div>

    <!-- Lessee -->
    <h3 style="margin:10px 0 6px; font-size:10px; letter-spacing:.12em; color:#444; text-transform:uppercase;">${lesseeTitle}</h3>
    <table aria-label="Lessee">
      <thead>
        <tr>
          <th> </th>
          <th class="center">Percentage</th>
          <th class="right">Dollar Value</th>
          <th class="center">Associate Split</th>
          <th class="center">House Split</th>
          <th class="right">Due to Associate</th>
        </tr>
      </thead>
      <tbody>
        <tr class="group"><td colspan="6">Outside Brokers</td></tr>
        ${distObj.lessee_outside_brokers.length === 0 ? `<tr>
                    <td><em>None</em></td>
                    <td class="center"></td>
                    <td class="right"></td>
                    <td class="center"></td>
                    <td class="center"></td>
                    <td class="right"></td>
                </tr>` : ``}
        ${distObj.lessee_outside_brokers.map(lob => {
            return `
                <tr>
                    <td>${lob.name}</td>
                    <td class="center">${formatPercentage(lob.percentage * 100)}</td>
                    <td class="right">${formatDollar(lob.dollar_value)}</td>
                    <td class="center">—</td>
                    <td class="center">—</td>
                    <td class="right">—</td>
                </tr>
            `;
        }).join('')}

        <tr class="group"><td colspan="6">Referrals</td></tr>
        ${distObj.lessee_referrals.length === 0 ? `<tr>
            <td><em>None</em></td>
            <td class="center"></td>
            <td class="right"></td>
            <td class="center"></td>
            <td class="center"></td>
            <td class="right"></td>
            </tr>` : ``}
        ${distObj.lessee_referrals.map(lob => {
            return `
                <tr>
                    <td>${lob.name}</td>
                    <td class="center">${lob.percentage ? formatPercentage(lob.percentage * 100) : ''}</td>
                    <td class="right">${formatDollar(lob.dollar_value)}</td>
                    <td class="center">—</td>
                    <td class="center">—</td>
                    <td class="right">—</td>
                </tr>
            `;
        }).join('')}

        <tr class="group"><td colspan="6">illi Associates</td></tr>
        ${distObj.lessee_illi_associates.length === 0 ? `<tr>
            <td><em>None</em></td>
            <td class="center"></td>
            <td class="right"></td>
            <td class="center"></td>
            <td class="center"></td>
            <td class="right"></td>
            </tr>` : ``}
        ${distObj.lessee_illi_associates.map(lob => {
            return `
                <tr>
                    <td>${lob.name}</td>
                    <td class="center">${formatPercentage(lob.percentage)}</td>
                    <td class="right">${formatDollar(lob.dollar_value)}</td>
                    <td class="center" ${lob.is_override ? 'style="color:red"' : ''}>${formatPercentage(lob.associate_split_percent)}</td>
                    <td class="center" ${lob.is_override ? 'style="color:red"' : ''}>${formatPercentage(lob.house_split_percent)}</td>
                    <td class="right">${formatDollar(lob.due_to_associate_number)}</td>
                </tr>
            `;
        }).join('')}
      </tbody>
    </table>

    <!-- Lessor -->
    <h3 style="margin:10px 0 6px; font-size:10px; letter-spacing:.12em; color:#444; text-transform:uppercase;">${lessorTitle}</h3>
    <table aria-label="Lessor">
      <thead>
        <tr>
          <th> </th>
          <th class="center">Percentage</th>
          <th class="right">Dollar Value</th>
          <th class="center">Associate Split</th>
          <th class="center">House Split</th>
          <th class="right">Due to Associate</th>
        </tr>
      </thead>
      <tbody>
        <tr class="group"><td colspan="6">Outside Brokers</td></tr>
        ${distObj.lessor_outside_brokers.length === 0 ? `<tr>
                    <td><em>None</em></td>
                    <td class="center"></td>
                    <td class="right"></td>
                    <td class="center"></td>
                    <td class="center"></td>
                    <td class="right"></td>
                </tr>` : ``}
        ${distObj.lessor_outside_brokers.map(lob => {
            return `
                <tr>
                    <td>${lob.name}</td>
                    <td class="center">${formatPercentage(lob.percentage * 100)}</td>
                    <td class="right">${formatDollar(lob.dollar_value)}</td>
                    <td class="center">—</td>
                    <td class="center">—</td>
                    <td class="right">—</td>
                </tr>
            `;
        }).join('')}

        <tr class="group"><td colspan="6">Referrals</td></tr>
        ${distObj.lessor_referrals.length === 0 ? `<tr>
            <td><em>None</em></td>
            <td class="center"></td>
            <td class="right"></td>
            <td class="center"></td>
            <td class="center"></td>
            <td class="right"></td>
            </tr>` : ``}
        ${distObj.lessor_referrals.map(lob => {
            return `
                <tr>
                    <td>${lob.name}</td>
                    <td class="center">${lob.percentage ? formatPercentage(lob.percentage * 100) : ''}</td>
                    <td class="right">${formatDollar(lob.dollar_value)}</td>
                    <td class="center">—</td>
                    <td class="center">—</td>
                    <td class="right">—</td>
                </tr>
            `;
        }).join('')}

        <tr class="group"><td colspan="6">illi Associates</td></tr>
        ${distObj.lessor_illi_associates.length === 0 ? `<tr>
            <td><em>None</em></td>
            <td class="center"></td>
            <td class="right"></td>
            <td class="center"></td>
            <td class="center"></td>
            <td class="right"></td>
            </tr>` : ``}
        ${distObj.lessor_illi_associates.map(lob => {
            return `
                <tr>
                    <td>${lob.name}</td>
                    <td class="center">${formatPercentage(lob.percentage)}</td>
                    <td class="right">${formatDollar(lob.dollar_value)}</td>
                    <td class="center" ${lob.is_override ? 'style="color:red"' : ''}>${formatPercentage(lob.associate_split_percent)}</td>
                    <td class="center" ${lob.is_override ? 'style="color:red"' : ''}>${formatPercentage(lob.house_split_percent)}</td>
                    <td class="right">${formatDollar(lob.due_to_associate_number)}</td>
                </tr>
            `;
        }).join('')}
      </tbody>
    </table>

    <!-- Totals -->
    <div class="totals-bar">TOTALS</div>
    <div class="totals-grid">
      <div class="totals-card">
        <h4>Outside Brokers</h4>
        ${distObj.lessee_outside_brokers.map(lob => {
            return `<div class="rowline"><span>${lob.name}</span><span>${formatDollar(lob.dollar_value)}</span></div>`
        }).join('')}
        ${distObj.lessor_outside_brokers.map(lob => {
            return `<div class="rowline"><span>${lob.name}</span><span>${formatDollar(lob.dollar_value)}</span></div>`
        }).join('')}
        <div class="rowline subtot"><span>TOTAL:</span><span>${formatDollar(distObj.total_outside_brokers)}</span></div>

        <h4 style="margin-top:14px;">Referrals</h4>
        ${distObj.presplits.map(pc => {
            console.log('pcds', pc);
            return `<div class="rowline"><span>${pc.name}</span><span>${formatDollar(parseFloatString(pc.val))}</span></div>`;
        }).join('')}
        ${distObj.lessee_referrals.map(lr => {
            return `<div class="rowline"><span>${lr.name}</span><span>${formatDollar(parseFloatString(lr.dollar_value))}</span></div>`;
        }).join('')} 
        ${distObj.lessor_referrals.map(lr => {
            return `<div class="rowline"><span>${lr.name}</span><span>${formatDollar(parseFloatString(lr.dollar_value))}</span></div>`;
        }).join('')}
        <div class="rowline subtot"><span>TOTAL:</span><span>${formatDollar(distObj.total_referrals)}</span></div>
      </div>

      <div class="totals-card">
        <h4>illi Associates</h4>
        ${Object.keys(distObj.all_assocs).map(name => {
            return `<div class="rowline"><span>${name}</span><span>${formatDollar(distObj.all_assocs[name])}</span></div>`
        }).join('')}

        <div class="rowline"><span>House</span><span>${formatDollar(distObj.total_house)}</span></div>

        <div class="rowline subtot"><span>TOTAL:</span><span>${formatDollar(distObj.total_illi_associates + distObj.total_house)}</span></div>

        <br>
        <br>
        <div class="rowline subtot">
            <span>TOTAL PAID:</span>
            <span>${formatDollar(distObj.total_paid)}</span>
        </div>

      </div>
    </div>

  </div>
  <div class="page-break"></div>

    `;

    return { distObj, html };
}

export const generatePaymentReportsHTML = (all_data) => {
    const html = `
    <html>
        <head>
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
            <link
                href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,500;1,400&display=swap"
                rel="stylesheet"
            />
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
            <link
                href="https://fonts.googleapis.com/css2?family=Didact+Gothic&display=swap"
                rel="stylesheet"
            />
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
            <link
                href="https://fonts.googleapis.com/css2?family=Roboto&display=swap"
                rel="stylesheet"
            />
            <link rel="stylesheet" href="https://use.typekit.net/fqe8cdb.css">
            <style>
            ${bootstrapHTML}
            </style>
            <style type="text/css">
                @import url("https://fonts.googleapis.com/css2?family=Didact+Gothic&display=swap");
                @import url("https://fonts.googleapis.com/css2?family=Roboto&display=swap");

                @font-face {
                    font-family: "Acumin Variable Concept";
                    font-weight: bold;
                    font-stretch: 70% 100%;
                    src: url("https://illicre.com/wp-content/uploads/Acumin-Variable-Concept.eot")
                            format("embedded-opentype"),
                        url("https://illicre.com/wp-content/uploads/Acumin-Variable-Concept.woff")
                            format("woff"),
                        url("https://illicre.com/wp-content/uploads/Acumin-Variable-Concept.ttf")
                            format("truetype");
                }

                @media print
                {
                table { page-break-after:auto }
                tr    { page-break-inside:avoid; page-break-after:auto }
                td    { page-break-inside:avoid; page-break-after:auto }
                thead { display:table-header-group }
                tfoot { display:table-footer-group }
                }

                html {
                    -webkit-print-color-adjust: exact;
                    -webkit-filter: opacity(1);
                }

                body {
                    margin-right: 20px;
                    font-size: 10px;
                    color: #131645;
                    font-family: "Didact Gothic", sans-serif !important;
                }

                p {
                    margin: 0;
                }
                table * {
                    font-size: 12px;
                }
                ol {
                    counter-reset: list;
                    padding-left: 1em;
                }

                .text-7 {
                    font-size: 10px;
                }

                .text-10 {
                    font-size: 12px;
                }

                .text-11 {
                    font-size: 14px;
                }

                .text-12 {
                    font-size: 15px !important;
                }

                .page-break {
                    page-break-after: avoid;
                }
                

                .text-center {
                    text-align: center !important;
                }

                hr {
                    border-bottom: 1px solid #ccc;
                }
                .white-text {
                    color: white;
                }
                #ertl-number {
                    text-align: right;
                }
                .times p,
                .times div {
                    font-family: "Times New Roman", Times, serif !important;
                }
                .font-14 {
                    font-size: 16px;
                }
                .font-10 {
                    font-size: 12px;
                }

                .date {
                    margin: 0 auto;
                    width: 70%;
                    display: flex;
                    justify-content: space-between;
                }
                .listing-table {
                    width: 100%;
                    border-collapse: collapse;
                }

                .listing-table td,
                .listing-table th {
                    border: 1px solid black;
                    padding: 5px;
                    height: 40px;
                }
                .width-15 {
                    width: 15%;
                }
                .width-10 {
                    width: 10%;
                }
                .width-17 {
                    width: 17%;
                }
                .custom-d-flex {
                    display: flex;
                    justify-content: space-between;
                }
                .red-text {
                    color: #da3b2f !important;
                }
                .header {
                    font-weight: bold;
                    margin: 0;
                    text-align: right;
                }
                .fwbold {
                    font-weight: bold;
                }
                .mt20 {
                    margin-top: 20px;
                }
                .img {
                    margin-bottom: 20px;
                    width: 100px;
                }
                .style1 {
                    border: 1px solid black;
                    margin-top: 20px;
                    padding: 10px;
                }
                .style2 {
                    display: inline-block;
                    font-weight: bold;
                    width: 150px;
                }
                .style3 {
                    border-spacing: 10px;
                    width: 100%;
                }
                .style4 {
                    text-align: left;
                    width: 200px;
                }
                .textRight {
                    text-align: right;
                }
                .style5 {
                    border-top: 1px solid black;
                    border-bottom: 1px solid black;
                }
                .style6 {
                    display: flex;
                    justify-content: space-between;
                }
                .style7 {
                    display: flex;
                    justify-content: center;
                }
                .invoice-table {
                    border: 0.5px solid #da2128;
                }

                .invoice-table table,
                table.invoice-detail {
                    border-collapse: collapse;
                }

                .invoice-table .bt {
                    border-top: 1px solid #da2128;
                    display: inline-block;
                }

                .gray-bg {
                    background-color: #ededed;
                }

                .invoice-detail {
                    padding: 5px;
                }

                .invoice-detail .gray-bg {
                    border-bottom: 1px solid black;
                }

                .invoice-heading {
                    color: #da2128;
                    font-size: 19px;
                    font-weight: bold;
                    font-stretch: 70%;
                    margin: 0;
                }
                .text-red {
                    color: #da2128;
                }
                .col-5 {
                    width: 5%;
                }
                .col-15 {
                    width: 15%;
                }
                .col-10 {
                    width: 10%;
                }

                .col-14 {
                    width: 14%;
                }

                .col-20 {
                    width: 20%;
                }

                .col-25 {
                    width: 25%;
                }

                .col-30 {
                    width: 30%;
                }

                .col-40 {
                    width: 40%;
                }
                .col-45 {
                    width: 45%;
                }

                .col-50 {
                    width: 50%;
                }

                .col-60 {
                    width: 60%;
                }

                .col-70 {
                    width: 70%;
                }

                .col-80 {
                    width: 80%;
                }

                .col-90 {
                    width: 90%;
                }

                .col-100 {
                    width: 100% !important;
                }
                .no-bt {
                    border-top: 1px solid rgba(0, 0, 0, 0) !important;
                }

                .no-bb {
                    border-bottom: 1px solid rgba(0, 0, 0, 0) !important;
                }
                .the-table .no-br {
                    border-right: 1px solid rgba(0, 0, 0, 0) !important;
                }

                .the-table .no-bl {
                    border-left: 1px solid rgba(0, 0, 0, 0) !important;
                }

                .the-table.border-red table,
                .the-table.border-red th,
                .the-table.border-red td {
                    border-color: #da2128;
                }
                .the-table table {
                    width: 100%;
                }

                .the-table table,
                .the-table th,
                .the-table td {
                    border: 1px solid #878787;
                    border-collapse: collapse;
                }

                .the-table td {
                    padding: 5px;
                }
                .inline-block {
                    display: inline-block;
                }
                .drop-shadow {
                    filter: drop-shadow(1px 1px 6px rgba(0, 0, 0, 0.18));
                }
                .box-shadow {
                    box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.18);
                }
                .fwsemibold {
                    font-weight: 600;
                }
                .gray-bar {
                    background-color: #ededed;
                    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 1px 1px;
                }
                .acumin-condense {
                    font-family: 'acumin-pro-condensed', sans-serif;
                }
                .acumin {
                    font-family: 'acumin-pro', sans-serif;
                }
                .condense {
                    font-stretch: 50%;
                }
                .fs-roboto {
                    font-family: "Roboto", sans-serif;
                }
                .col-container {
                    column-count: 2;
                }
                .col1 {
                    column-span: 1;
                }
                .col2 {
                    column-span: 10;
                }
                td {
                    vertical-align:top
                }
            </style>
        </head>

        <body>
            ${

                renderReportHTML(all_data)}
        </body>
    </html>
        `;


    return html;
}
